import React from 'react';

import { Space } from 'antd-v5';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui/lib';

import type { UserOrganizationInfo } from '@modules/user/duck/types';
import {
  ProgramColors,
  ProgramLogo,
  ProgramName,
  UnitGenderPill,
} from '@shared/components';

import styles from './RolePickerRole.less';
import RolePickerBaseRole from './components/RolePickerBaseRole';

interface RolePickerUnitRoleProps {
  active: boolean;
  disabled: boolean;
  org: UserOrganizationInfo;
  onProfileChange: (organizationGuid: string) => void;
}

function RolePickerUnitRole(props: RolePickerUnitRoleProps) {
  const { active, disabled, org, onProfileChange } = props;
  const positionNames = org.role;
  const extraPositions = _.chain(org)
    .get('allRoles')
    .uniq()
    .filter(position => position !== positionNames)
    .value();
  const extraPositionsLabel = extraPositions.join('\n');
  const hasExtraPositions = extraPositions.length > 0;

  const organizationGuid = org.organizationGuid;

  return (
    <RolePickerBaseRole
      org={org}
      active={active}
      disabled={disabled}
      onProfileChange={onProfileChange}
    >
      <ProgramColors program={org.program}>
        <ProgramLogo program={org.program} className={styles.logo} />
      </ProgramColors>
      <div
        className={styles.description}
        data-testid={`unit:${organizationGuid}`}
      >
        <Space direction="vertical" size={0}>
          <Text>
            <ProgramName program={org.program} />
          </Text>
          <Text font="body-caption">
            {org.organizationName}{' '}
            <UnitGenderPill
              gender={org.acceptGender}
              colored
              splitFamilyLabel
            />
          </Text>
          <Text font="body-caption">
            <FormattedMessage id="context.RolePicker.position" />:{' '}
            {positionNames}
          </Text>
          {hasExtraPositions && (
            <Text
              className={styles.extraPositionsLabel}
              font="body-caption"
              title={extraPositionsLabel}
            >
              <FormattedMessage
                id="context.RolePicker.extraPositions"
                values={{ count: extraPositions.length }}
              />
            </Text>
          )}
        </Space>
      </div>
    </RolePickerBaseRole>
  );
}

export default RolePickerUnitRole;
